import { render, staticRenderFns } from "./_favoriteorders.vue?vue&type=template&id=1185e37e&"
import script from "./_favoriteorders.vue?vue&type=script&lang=ts&"
export * from "./_favoriteorders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1185e37e')) {
      api.createRecord('1185e37e', component.options)
    } else {
      api.reload('1185e37e', component.options)
    }
    module.hot.accept("./_favoriteorders.vue?vue&type=template&id=1185e37e&", function () {
      api.rerender('1185e37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/mypages/_favoriteorders.vue"
export default component.exports